import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin: ', 'px\n    ', 'px 0 ', 'px;\n'], ['\n  display: flex;\n  align-items: center;\n  margin: ', 'px\n    ', 'px 0 ', 'px;\n']);

import styled from 'styled-components';

import { gridSize, math } from '@atlaskit/theme';

var SkeletonDefaultContainerHeaderInner = styled.div(_templateObject, function (props) {
  return props.isAvatarHidden ? gridSize() * 2 : math.divide(gridSize, 2);
}, gridSize(), gridSize());

SkeletonDefaultContainerHeaderInner.displayName = 'SkeletonDefaultContainerHeaderInner';
export default SkeletonDefaultContainerHeaderInner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/skeleton/styled/SkeletonDefaultContainerHeaderInner.js
// module id = 767
// module chunks = 0